import { useRepositories } from '../../../contexts';
import { InvalidationTag, LoaderType, useAppQuery } from '../utils';
import { useLanguage } from '../../../locale';
export var useGetFavouriteApi = function () {
    var _a = useLanguage(), locale = _a[2];
    var favouriteRepo = useRepositories().favouriteRepo;
    var getFavourite = useAppQuery([InvalidationTag.Favourite, locale], favouriteRepo.getFavourite, {}, LoaderType.None);
    return getFavourite;
};
